import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from 'ogp/paths';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useCreateWorkflow } from './use-create-workflow';
import { WorkflowCreateForm } from '../pages/create/workflow-create-toolbox';
import { MappedWorkflowNode } from '../components/workflow-editor/mappers/map-canvas-content.types';

type Props = {
  mapNodesToDto: () => MappedWorkflowNode[];
};

export const useWorkflowCreateSubmit = ({ mapNodesToDto }: Props) => {
  const mutation = useCreateWorkflow();
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();

  const onSubmit = useCallback(
    (data: WorkflowCreateForm) => {
      const graphData = mapNodesToDto();

      mutation.mutate(
        {
          workflowName: data.workflowName,
          graphData,
        },
        {
          onSuccess: () => {
            navigate(generatePath(paths.Workflows));
          },
        }
      );
    },
    [mapNodesToDto, mutation, navigate, generatePath]
  );

  return { onSubmit, mutation };
};
